/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "bankreconciliation/models.proto" (package "rd.bankreconciliation", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Money } from "../proto/money/models_pb";
import { User } from "../user/models_pb";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { UUID } from "../proto/uuid/models_pb";
/**
 * BankReconciliation is a record of a bank reconciliation for a given external account.
 *
 * @generated from protobuf message rd.bankreconciliation.BankReconciliation
 */
export interface BankReconciliation {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 5
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 6
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID external_account_id = 7
     */
    externalAccountId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp statement_start_date = 8
     */
    statementStartDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp statement_end_date = 9
     */
    statementEndDate?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money statement_starting_balance = 10
     */
    statementStartingBalance?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money statement_ending_balance = 11
     */
    statementEndingBalance?: Money;
    /**
     * @generated from protobuf field: rd.bankreconciliation.BankReconciliation.Status status = 12
     */
    status: BankReconciliation_Status;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 13
     */
    completedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User completed_by = 14
     */
    completedBy?: User;
    /**
     * @generated from protobuf field: string void_reason = 15
     */
    voidReason: string;
}
/**
 * @generated from protobuf enum rd.bankreconciliation.BankReconciliation.Status
 */
export enum BankReconciliation_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_IN_PROGRESS = 1;
     */
    IN_PROGRESS = 1,
    /**
     * @generated from protobuf enum value: STATUS_COMPLETED = 2;
     */
    COMPLETED = 2,
    /**
     * @generated from protobuf enum value: STATUS_VOIDED = 3;
     */
    VOIDED = 3
}
/**
 * ImportedTransaction is a record of a transaction that was imported from a bank statement.
 * Additionally, one imported transaction can only be part of one active or suggested
 * match group. An imported transaction can be part of multiple inactive match groups.
 *
 * @generated from protobuf message rd.bankreconciliation.ImportedTransaction
 */
export interface ImportedTransaction {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 5
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 6
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID bank_reconciliation_id = 7
     */
    bankReconciliationId?: UUID;
    /**
     * Properties from the bank statement
     *
     * @generated from protobuf field: string type = 8
     */
    type: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp posted_at = 9
     */
    postedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 10
     */
    amount?: Money;
    /**
     * @generated from protobuf field: string name = 11
     */
    name: string;
    /**
     * @generated from protobuf field: string memo = 12
     */
    memo: string;
    /**
     * @generated from protobuf field: string transaction_id = 13
     */
    transactionId: string;
}
/**
 * ReconciliationMatchGroup is a group of transactions that were matched during a bank
 * reconciliation. The sum of the amounts of the imported transactions must equal the sum of the
 * amounts of the external transactions. Additionally, one external transaction can only be part of
 * one active or suggested match group. An external transaction can be part of multiple inactive
 * match groups.
 *
 * @generated from protobuf message rd.bankreconciliation.ReconciliationMatchGroup
 */
export interface ReconciliationMatchGroup {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 5
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 6
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID bank_reconciliation_id = 7
     */
    bankReconciliationId?: UUID;
    /**
     * @generated from protobuf field: rd.bankreconciliation.ReconciliationMatchGroup.Status status = 8
     */
    status: ReconciliationMatchGroup_Status;
    /**
     * @generated from protobuf field: rd.bankreconciliation.ReconciliationMatchGroup.Source source = 9
     */
    source: ReconciliationMatchGroup_Source;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID external_transaction_ids = 10
     */
    externalTransactionIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID imported_transaction_ids = 11
     */
    importedTransactionIds: UUID[];
}
/**
 * @generated from protobuf enum rd.bankreconciliation.ReconciliationMatchGroup.Status
 */
export enum ReconciliationMatchGroup_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_SUGGESTED = 1;
     */
    SUGGESTED = 1,
    /**
     * @generated from protobuf enum value: STATUS_ACTIVE = 2;
     */
    ACTIVE = 2,
    /**
     * @generated from protobuf enum value: STATUS_VOIDED = 3;
     */
    VOIDED = 3
}
/**
 * @generated from protobuf enum rd.bankreconciliation.ReconciliationMatchGroup.Source
 */
export enum ReconciliationMatchGroup_Source {
    /**
     * @generated from protobuf enum value: SOURCE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: SOURCE_SUGGESTED = 1;
     */
    SUGGESTED = 1,
    /**
     * @generated from protobuf enum value: SOURCE_MANUAL = 2;
     */
    MANUAL = 2,
    /**
     * new external transaction recorded for this reconciliation
     *
     * @generated from protobuf enum value: SOURCE_RECORDED = 3;
     */
    RECORDED = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class BankReconciliation$Type extends MessageType<BankReconciliation> {
    constructor() {
        super("rd.bankreconciliation.BankReconciliation", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_by", kind: "message", T: () => User },
            { no: 6, name: "company_id", kind: "message", T: () => UUID },
            { no: 7, name: "external_account_id", kind: "message", T: () => UUID },
            { no: 8, name: "statement_start_date", kind: "message", T: () => Timestamp },
            { no: 9, name: "statement_end_date", kind: "message", T: () => Timestamp },
            { no: 10, name: "statement_starting_balance", kind: "message", T: () => Money },
            { no: 11, name: "statement_ending_balance", kind: "message", T: () => Money },
            { no: 12, name: "status", kind: "enum", T: () => ["rd.bankreconciliation.BankReconciliation.Status", BankReconciliation_Status, "STATUS_"] },
            { no: 13, name: "completed_at", kind: "message", T: () => Timestamp },
            { no: 14, name: "completed_by", kind: "message", T: () => User },
            { no: 15, name: "void_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BankReconciliation>): BankReconciliation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        message.voidReason = "";
        if (value !== undefined)
            reflectionMergePartial<BankReconciliation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BankReconciliation): BankReconciliation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User updated_by */ 5:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 6:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID external_account_id */ 7:
                    message.externalAccountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.externalAccountId);
                    break;
                case /* google.protobuf.Timestamp statement_start_date */ 8:
                    message.statementStartDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.statementStartDate);
                    break;
                case /* google.protobuf.Timestamp statement_end_date */ 9:
                    message.statementEndDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.statementEndDate);
                    break;
                case /* rd.proto.money.Money statement_starting_balance */ 10:
                    message.statementStartingBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.statementStartingBalance);
                    break;
                case /* rd.proto.money.Money statement_ending_balance */ 11:
                    message.statementEndingBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.statementEndingBalance);
                    break;
                case /* rd.bankreconciliation.BankReconciliation.Status status */ 12:
                    message.status = reader.int32();
                    break;
                case /* google.protobuf.Timestamp completed_at */ 13:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* rd.user.User completed_by */ 14:
                    message.completedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.completedBy);
                    break;
                case /* string void_reason */ 15:
                    message.voidReason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BankReconciliation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 5; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 6; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID external_account_id = 7; */
        if (message.externalAccountId)
            UUID.internalBinaryWrite(message.externalAccountId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp statement_start_date = 8; */
        if (message.statementStartDate)
            Timestamp.internalBinaryWrite(message.statementStartDate, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp statement_end_date = 9; */
        if (message.statementEndDate)
            Timestamp.internalBinaryWrite(message.statementEndDate, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money statement_starting_balance = 10; */
        if (message.statementStartingBalance)
            Money.internalBinaryWrite(message.statementStartingBalance, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money statement_ending_balance = 11; */
        if (message.statementEndingBalance)
            Money.internalBinaryWrite(message.statementEndingBalance, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.bankreconciliation.BankReconciliation.Status status = 12; */
        if (message.status !== 0)
            writer.tag(12, WireType.Varint).int32(message.status);
        /* google.protobuf.Timestamp completed_at = 13; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User completed_by = 14; */
        if (message.completedBy)
            User.internalBinaryWrite(message.completedBy, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* string void_reason = 15; */
        if (message.voidReason !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.voidReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.bankreconciliation.BankReconciliation
 */
export const BankReconciliation = new BankReconciliation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImportedTransaction$Type extends MessageType<ImportedTransaction> {
    constructor() {
        super("rd.bankreconciliation.ImportedTransaction", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_by", kind: "message", T: () => User },
            { no: 6, name: "company_id", kind: "message", T: () => UUID },
            { no: 7, name: "bank_reconciliation_id", kind: "message", T: () => UUID },
            { no: 8, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "posted_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "amount", kind: "message", T: () => Money },
            { no: 11, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "memo", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "transaction_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ImportedTransaction>): ImportedTransaction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = "";
        message.name = "";
        message.memo = "";
        message.transactionId = "";
        if (value !== undefined)
            reflectionMergePartial<ImportedTransaction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImportedTransaction): ImportedTransaction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User updated_by */ 5:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 6:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID bank_reconciliation_id */ 7:
                    message.bankReconciliationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.bankReconciliationId);
                    break;
                case /* string type */ 8:
                    message.type = reader.string();
                    break;
                case /* google.protobuf.Timestamp posted_at */ 9:
                    message.postedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.postedAt);
                    break;
                case /* rd.proto.money.Money amount */ 10:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* string name */ 11:
                    message.name = reader.string();
                    break;
                case /* string memo */ 12:
                    message.memo = reader.string();
                    break;
                case /* string transaction_id */ 13:
                    message.transactionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImportedTransaction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 5; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 6; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID bank_reconciliation_id = 7; */
        if (message.bankReconciliationId)
            UUID.internalBinaryWrite(message.bankReconciliationId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string type = 8; */
        if (message.type !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.type);
        /* google.protobuf.Timestamp posted_at = 9; */
        if (message.postedAt)
            Timestamp.internalBinaryWrite(message.postedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money amount = 10; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string name = 11; */
        if (message.name !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.name);
        /* string memo = 12; */
        if (message.memo !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.memo);
        /* string transaction_id = 13; */
        if (message.transactionId !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.transactionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.bankreconciliation.ImportedTransaction
 */
export const ImportedTransaction = new ImportedTransaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReconciliationMatchGroup$Type extends MessageType<ReconciliationMatchGroup> {
    constructor() {
        super("rd.bankreconciliation.ReconciliationMatchGroup", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "updated_by", kind: "message", T: () => User },
            { no: 6, name: "company_id", kind: "message", T: () => UUID },
            { no: 7, name: "bank_reconciliation_id", kind: "message", T: () => UUID },
            { no: 8, name: "status", kind: "enum", T: () => ["rd.bankreconciliation.ReconciliationMatchGroup.Status", ReconciliationMatchGroup_Status, "STATUS_"] },
            { no: 9, name: "source", kind: "enum", T: () => ["rd.bankreconciliation.ReconciliationMatchGroup.Source", ReconciliationMatchGroup_Source, "SOURCE_"] },
            { no: 10, name: "external_transaction_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 11, name: "imported_transaction_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<ReconciliationMatchGroup>): ReconciliationMatchGroup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        message.source = 0;
        message.externalTransactionIds = [];
        message.importedTransactionIds = [];
        if (value !== undefined)
            reflectionMergePartial<ReconciliationMatchGroup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReconciliationMatchGroup): ReconciliationMatchGroup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User updated_by */ 5:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 6:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID bank_reconciliation_id */ 7:
                    message.bankReconciliationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.bankReconciliationId);
                    break;
                case /* rd.bankreconciliation.ReconciliationMatchGroup.Status status */ 8:
                    message.status = reader.int32();
                    break;
                case /* rd.bankreconciliation.ReconciliationMatchGroup.Source source */ 9:
                    message.source = reader.int32();
                    break;
                case /* repeated rd.proto.uuid.UUID external_transaction_ids */ 10:
                    message.externalTransactionIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.proto.uuid.UUID imported_transaction_ids */ 11:
                    message.importedTransactionIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReconciliationMatchGroup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 5; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 6; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID bank_reconciliation_id = 7; */
        if (message.bankReconciliationId)
            UUID.internalBinaryWrite(message.bankReconciliationId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.bankreconciliation.ReconciliationMatchGroup.Status status = 8; */
        if (message.status !== 0)
            writer.tag(8, WireType.Varint).int32(message.status);
        /* rd.bankreconciliation.ReconciliationMatchGroup.Source source = 9; */
        if (message.source !== 0)
            writer.tag(9, WireType.Varint).int32(message.source);
        /* repeated rd.proto.uuid.UUID external_transaction_ids = 10; */
        for (let i = 0; i < message.externalTransactionIds.length; i++)
            UUID.internalBinaryWrite(message.externalTransactionIds[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID imported_transaction_ids = 11; */
        for (let i = 0; i < message.importedTransactionIds.length; i++)
            UUID.internalBinaryWrite(message.importedTransactionIds[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.bankreconciliation.ReconciliationMatchGroup
 */
export const ReconciliationMatchGroup = new ReconciliationMatchGroup$Type();
